module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock-threshold-panel"
  }, [_c('div', {
    staticClass: "stock-tp-header"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "stock-tp-close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.requestClose
    }
  }, [_c('i', {
    staticClass: "close icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "stock-tp-tabs"
  }, [_c('button', {
    class: ['stock-tp-tab', {
      active: _vm.activeTab === 'fba'
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'fba'
      }
    }
  }, [_c('i', {
    staticClass: "cube icon"
  }), _vm._v("\n      FBA Stock\n      "), _c('span', {
    staticClass: "stock-tp-tab-count"
  }, [_vm._v(_vm._s(_vm.fbaRows.length) + " products")])]), _vm._v(" "), _c('button', {
    class: ['stock-tp-tab', {
      active: _vm.activeTab === 'fbm'
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'fbm'
      }
    }
  }, [_c('i', {
    staticClass: "home icon"
  }), _vm._v("\n      FBM Stock\n      "), _c('span', {
    staticClass: "stock-tp-tab-count"
  }, [_vm._v(_vm._s(_vm.fbmRows.length) + " products")])])]), _vm._v(" "), _c('div', {
    class: ['stock-tp-pane', {
      active: _vm.activeTab === 'fba'
    }]
  }, [(_vm.fbaTotalCount > _vm.fbaRows.length) ? _c('p', {
    staticClass: "stock-tp-cap-note"
  }, [_vm._v("\n      Showing "), _c('strong', [_vm._v(_vm._s(_vm.fbaRows.length))]), _vm._v(" of "), _c('strong', [_vm._v(_vm._s(_vm.fbaTotalCount))]), _vm._v(" listings on this server page.\n      Use "), _c('strong', [_vm._v("Download CSV")]), _vm._v(" for the full catalog or adjust API pagination.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "stock-tp-table-wrap"
  }, [(_vm.fbaRows.length > 0) ? _c('table', {
    staticClass: "stock-tp-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.fbaRows), function(p) {
    return _c('tr', {
      key: 'fba-' + _vm.listingId(p) + '-' + _vm.thresholdsDataRevision,
      class: {
        'stock-tp-row-dirty': _vm.rowDirtyFba[_vm.listingId(p)]
      }
    }, [_c('td', [_c('span', {
      staticClass: "stock-tp-product-name",
      attrs: {
        "title": p.productTitle
      }
    }, [_vm._v(_vm._s(p.productTitle))]), _vm._v(" "), _c('div', {
      staticClass: "stock-tp-product-meta"
    }, [_c('span', {
      staticClass: "stock-tp-asin"
    }, [_vm._v(_vm._s(_vm.asinFor(p)))]), _vm._v(" "), _c('span', {
      staticClass: "stock-tp-mkt"
    }, [_c('i', {
      class: _vm.flagClass(p.marketplace) + ' flag'
    }), _vm._v("\n                  " + _vm._s(_vm.marketplaceLabel(p.marketplace)) + "\n                ")])])]), _vm._v(" "), _c('td', {
      staticClass: "stock-tp-td-center"
    }, [_c('div', {
      staticClass: "stock-tp-input-cell"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.fbaForms[_vm.listingId(p)].amberThreshold),
        expression: "fbaForms[listingId(p)].amberThreshold",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "stock-tp-input",
      class: _vm.inputClassesFba(_vm.listingId(p), 'amberThreshold'),
      attrs: {
        "type": "number",
        "min": "-1",
        "placeholder": "—"
      },
      domProps: {
        "value": (_vm.fbaForms[_vm.listingId(p)].amberThreshold)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.fbaForms[_vm.listingId(p)], "amberThreshold", _vm._n($event.target.value))
        }, function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        }],
        "change": function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "stock-tp-input-unit"
    }, [_vm._v("units")])])]), _vm._v(" "), _c('td', {
      staticClass: "stock-tp-td-center"
    }, [_c('div', {
      staticClass: "stock-tp-input-cell"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.fbaForms[_vm.listingId(p)].redThreshold),
        expression: "fbaForms[listingId(p)].redThreshold",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "stock-tp-input",
      class: _vm.inputClassesFba(_vm.listingId(p), 'redThreshold'),
      attrs: {
        "type": "number",
        "min": "-1",
        "placeholder": "—"
      },
      domProps: {
        "value": (_vm.fbaForms[_vm.listingId(p)].redThreshold)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.fbaForms[_vm.listingId(p)], "redThreshold", _vm._n($event.target.value))
        }, function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        }],
        "change": function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "stock-tp-input-unit"
    }, [_vm._v("units")])])]), _vm._v(" "), _c('td', {
      staticClass: "stock-tp-td-center"
    }, [_c('div', {
      staticClass: "stock-tp-input-cell"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.fbaForms[_vm.listingId(p)].amberDays),
        expression: "fbaForms[listingId(p)].amberDays",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "stock-tp-input",
      class: _vm.inputClassesFba(_vm.listingId(p), 'amberDays'),
      attrs: {
        "type": "number",
        "min": "-1",
        "placeholder": "—"
      },
      domProps: {
        "value": (_vm.fbaForms[_vm.listingId(p)].amberDays)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.fbaForms[_vm.listingId(p)], "amberDays", _vm._n($event.target.value))
        }, function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        }],
        "change": function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "stock-tp-input-unit"
    }, [_vm._v("days")])])]), _vm._v(" "), _c('td', {
      staticClass: "stock-tp-td-center"
    }, [_c('div', {
      staticClass: "stock-tp-input-cell"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.fbaForms[_vm.listingId(p)].redDays),
        expression: "fbaForms[listingId(p)].redDays",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "stock-tp-input",
      class: _vm.inputClassesFba(_vm.listingId(p), 'redDays'),
      attrs: {
        "type": "number",
        "min": "-1",
        "placeholder": "—"
      },
      domProps: {
        "value": (_vm.fbaForms[_vm.listingId(p)].redDays)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.fbaForms[_vm.listingId(p)], "redDays", _vm._n($event.target.value))
        }, function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        }],
        "change": function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "stock-tp-input-unit"
    }, [_vm._v("days")])])]), _vm._v(" "), _c('td', {
      staticClass: "stock-tp-td-center"
    }, [_c('div', {
      staticClass: "stock-tp-input-cell"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.fbaForms[_vm.listingId(p)].velocityLookbackDays),
        expression: "fbaForms[listingId(p)].velocityLookbackDays",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "stock-tp-input",
      class: _vm.inputClassesFba(_vm.listingId(p), 'velocityLookbackDays'),
      attrs: {
        "type": "number",
        "min": "1",
        "placeholder": "14"
      },
      domProps: {
        "value": (_vm.fbaForms[_vm.listingId(p)].velocityLookbackDays)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.fbaForms[_vm.listingId(p)], "velocityLookbackDays", _vm._n($event.target.value))
        }, function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        }],
        "change": function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "stock-tp-input-unit"
    }, [_vm._v("days")])])])])
  }), 0)]) : _c('div', {
    staticClass: "stock-tp-empty"
  }, [_vm._v("No FBA listings returned for thresholds.")])])]), _vm._v(" "), _c('div', {
    class: ['stock-tp-pane', {
      active: _vm.activeTab === 'fbm'
    }]
  }, [(_vm.fbmTotalCount > _vm.fbmRows.length) ? _c('p', {
    staticClass: "stock-tp-cap-note"
  }, [_vm._v("\n      Showing "), _c('strong', [_vm._v(_vm._s(_vm.fbmRows.length))]), _vm._v(" of "), _c('strong', [_vm._v(_vm._s(_vm.fbmTotalCount))]), _vm._v(" FBM listings on this server page.\n      Use "), _c('strong', [_vm._v("Download CSV")]), _vm._v(" for the full catalog or adjust API pagination.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "stock-tp-table-wrap"
  }, [(_vm.fbmRows.length > 0) ? _c('table', {
    staticClass: "stock-tp-table"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.fbmRows), function(p) {
    return _c('tr', {
      key: 'fbm-' + _vm.listingId(p) + '-' + _vm.thresholdsDataRevision,
      class: {
        'stock-tp-row-dirty': _vm.rowDirtyFbm[_vm.listingId(p)]
      }
    }, [_c('td', [_c('span', {
      staticClass: "stock-tp-product-name",
      attrs: {
        "title": p.productTitle
      }
    }, [_vm._v(_vm._s(p.productTitle))]), _vm._v(" "), _c('div', {
      staticClass: "stock-tp-product-meta"
    }, [_c('span', {
      staticClass: "stock-tp-asin"
    }, [_vm._v(_vm._s(_vm.asinFor(p)))]), _vm._v(" "), _c('span', {
      staticClass: "stock-tp-mkt"
    }, [_vm._v("FBM — own warehouse")])])]), _vm._v(" "), _c('td', {
      staticClass: "stock-tp-td-center"
    }, [_c('span', {
      staticClass: "stock-tp-mkt"
    }, [_c('i', {
      class: _vm.flagClass(p.marketplace) + ' flag'
    }), _vm._v("\n                " + _vm._s(_vm.marketplaceLabel(p.marketplace)) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "stock-tp-td-center"
    }, [_c('div', {
      staticClass: "stock-tp-input-cell"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.fbmForms[_vm.listingId(p)].threshold),
        expression: "fbmForms[listingId(p)].threshold",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "stock-tp-input",
      class: _vm.inputClassesFbmObj(_vm.listingId(p)),
      attrs: {
        "type": "number",
        "min": "0",
        "placeholder": "—"
      },
      domProps: {
        "value": (_vm.fbmForms[_vm.listingId(p)].threshold)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.fbmForms[_vm.listingId(p)], "threshold", _vm._n($event.target.value))
        }, function($event) {
          _vm.markFbmDirty(_vm.listingId(p))
        }],
        "change": function($event) {
          _vm.markFbmDirty(_vm.listingId(p))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "stock-tp-input-unit"
    }, [_vm._v("units")])])])])
  }), 0)]) : _c('div', {
    staticClass: "stock-tp-empty"
  }, [_vm._v("No FBM listings returned for thresholds.")])])]), _vm._v(" "), _c('div', {
    staticClass: "stock-tp-csv-strip"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "stock-tp-csv-actions"
  }, [_c('button', {
    staticClass: "stock-tp-btn-csv stock-tp-btn-csv-dl",
    attrs: {
      "type": "button",
      "disabled": _vm.csvDownloading
    },
    on: {
      "click": _vm.downloadCsv
    }
  }, [_c('i', {
    class: _vm.csvDownloading ? 'notched circle loading icon' : 'download icon'
  }), _vm._v("\n        " + _vm._s(_vm.csvDownloading ? 'Downloading…' : 'Download CSV') + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "stock-tp-csv-divider"
  }), _vm._v(" "), _c('label', {
    staticClass: "stock-tp-btn-csv stock-tp-btn-csv-ul"
  }, [_c('i', {
    staticClass: "upload icon"
  }), _vm._v("\n        Upload CSV\n        "), _c('input', {
    staticClass: "stock-tp-csv-file",
    attrs: {
      "type": "file",
      "accept": ".csv,text/csv,application/csv"
    },
    on: {
      "change": _vm.uploadCsv
    }
  })])])]), _vm._v(" "), _c('div', {
    class: ['stock-tp-dirty-banner', {
      visible: _vm.dirty
    }]
  }, [_c('i', {
    staticClass: "exclamation triangle icon"
  }), _vm._v("\n    You have unsaved changes.\n  ")]), _vm._v(" "), (_vm.thresholdsLoading) ? _c('div', {
    staticClass: "stock-tp-loading-banner"
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v("\n    Loading thresholds…\n  ")]) : _vm._e(), _vm._v(" "), (_vm.thresholdsLoadError && !_vm.thresholdsLoading) ? _c('div', {
    staticClass: "stock-tp-panel-error stock-tp-load-warning"
  }, [_vm._v("\n    " + _vm._s(_vm.thresholdsLoadError) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "stock-tp-footer"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "stock-tp-footer-actions"
  }, [_c('button', {
    staticClass: "stock-tp-btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.requestClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "stock-tp-btn-save",
    attrs: {
      "type": "button",
      "disabled": _vm.saving || !_vm.hasRowsToSaveOnActiveTab
    },
    on: {
      "click": _vm.saveAll
    }
  }, [(_vm.saving) ? _c('i', {
    staticClass: "notched circle loading icon"
  }) : _vm._e(), _vm._v("\n        Save All Thresholds\n      ")])])]), _vm._v(" "), (_vm.saveError) ? _c('div', {
    staticClass: "stock-tp-panel-error"
  }, [_vm._v(_vm._s(_vm.saveError))]) : _vm._e(), _vm._v(" "), (_vm.csvMessage) ? _c('div', {
    class: _vm.csvMessageIsError ? 'stock-tp-panel-error' : 'stock-tp-csv-toast'
  }, [_vm._v(_vm._s(_vm.csvMessage))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock-tp-header-icon"
  }, [_c('i', {
    staticClass: "setting icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "stock-tp-title"
  }, [_vm._v("Stock Alert Thresholds")]), _vm._v(" "), _c('div', {
    staticClass: "stock-tp-subtitle"
  }, [_vm._v("\n        Configure per-ASIN stock thresholds across your full product portfolio. These drive Low Stock & Out of Stock alerts on the Alerts page.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "min-width": "220px"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Product")]), _vm._v(" "), _c('th', {
    staticClass: "stock-tp-th-center stock-tp-th-units-group",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Alert by Units")]), _vm._v(" "), _c('th', {
    staticClass: "stock-tp-th-center stock-tp-th-days-group",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Alert by Days of Stock")]), _vm._v(" "), _c('th', {
    staticClass: "stock-tp-th-center stock-tp-th-interval",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Avg Calc Interval")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "stock-tp-th-center stock-tp-th-sub-units"
  }, [_vm._v("Warning threshold")]), _vm._v(" "), _c('th', {
    staticClass: "stock-tp-th-center stock-tp-th-sub-units"
  }, [_vm._v("Critical alert")]), _vm._v(" "), _c('th', {
    staticClass: "stock-tp-th-center stock-tp-th-sub-days"
  }, [_vm._v("Warning threshold")]), _vm._v(" "), _c('th', {
    staticClass: "stock-tp-th-center stock-tp-th-sub-days"
  }, [_vm._v("Critical alert")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "min-width": "220px"
    }
  }, [_vm._v("Product")]), _vm._v(" "), _c('th', {
    staticClass: "stock-tp-th-center stock-tp-th-sub-units"
  }, [_vm._v("Marketplace")]), _vm._v(" "), _c('th', {
    staticClass: "stock-tp-th-center stock-tp-th-sub-units"
  }, [_vm._v("Alert below")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock-tp-csv-label"
  }, [_c('i', {
    staticClass: "info circle icon"
  }), _vm._v(" "), _c('span', [_vm._v("Managing a large catalog? "), _c('strong', [_vm._v("Download as CSV")]), _vm._v(" → edit thresholds in bulk → re-upload.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock-tp-footer-note"
  }, [_c('i', {
    staticClass: "info circle icon"
  }), _vm._v("\n      Leave any field blank to use account defaults (14 days for Low Stock). Thresholds apply to both the Stock page status and Alerts page triggers.\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ccbbb3e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stock/StockAlertThresholdsPanel.vue
// module id = 770
// module chunks = 2